var agp = agp || {};

agp.tablesorter = (function() {

	function init () {
		$("table.sort").tablesorter({
			// pass the headers argument and assing a object 
			headers: {
				0: {
					sorter: false //status
				},
				3: {
					sorter: false //regulering
				},
				4: {
					sorter: false //Sidste md.
				},
				5: {
					sorter: false //Denne md.
				},
				6: {
					sorter: false //Redigeret af
				},
				7: {
					sorter: false //Edit
				}
			}
		});
	}

	return {
		init: init
	};

}());